//#region src/adapters/WebStorageAdapter.ts
var e = class {
	async read(e) {
		return localStorage.getItem(e);
	}
	async write(e, t) {
		localStorage.setItem(e, t);
	}
	async delete(e) {
		localStorage.removeItem(e);
	}
	async listKeys(e) {
		return Object.keys(localStorage).filter((t) => t.startsWith(e));
	}
};
//#endregion
export { e as WebStorageAdapter };
